import React from 'react';
import {
  QuestionCard, OptionRow, OptionInputControl, RequiredMark, Input, TextArea,
} from './surveyTheme.styles';

// One question's read/answer UI — shared by the authenticated SurveyPlayer
// and the public magic-link PublicSurveyPlayer (identical rendering either
// way; only how the surrounding page loads/submits data differs).
export default function SurveyQuestionBlock({ question, answer, isReadOnly, onSingleChoice, onToggleMulti, onText }) {
  const options = question.options;

  return (
    <QuestionCard>
      <p style={{ fontWeight: 600, marginTop: 0, marginBottom: '1rem', fontSize: '1.05rem', color: 'var(--text-primary)' }}>
        {question.prompt}{question.required && <RequiredMark>*</RequiredMark>}
      </p>

      {(question.type === 'single_choice' || question.type === 'yes_no') && options.map(opt => (
        <OptionRow key={opt.id} $checked={answer.optionIds.has(opt.id)}>
          <OptionInputControl
            type="radio"
            name={`q-${question.id}`}
            checked={answer.optionIds.has(opt.id)}
            disabled={isReadOnly}
            onChange={() => onSingleChoice(question.id, opt.id)}
          />
          {opt.option_text}
        </OptionRow>
      ))}

      {question.type === 'multi_choice' && options.map(opt => (
        <OptionRow key={opt.id} $checked={answer.optionIds.has(opt.id)}>
          <OptionInputControl
            type="checkbox"
            checked={answer.optionIds.has(opt.id)}
            disabled={isReadOnly}
            onChange={() => onToggleMulti(question.id, opt.id, question.settings.maxSelections)}
          />
          {opt.option_text}
        </OptionRow>
      ))}

      {(question.type === 'short_answer') && (
        <Input value={answer.answerText} disabled={isReadOnly} onChange={(e) => onText(question.id, e.target.value)} />
      )}

      {(question.type === 'long_answer') && (
        <TextArea style={{ minHeight: 110 }} value={answer.answerText} disabled={isReadOnly} onChange={(e) => onText(question.id, e.target.value)} />
      )}

      {(question.type === 'single_choice' || question.type === 'multi_choice') && options.some(o => o.allow_free_text && answer.optionIds.has(o.id)) && (
        <Input
          style={{ marginTop: 8 }}
          placeholder="Please specify…"
          value={answer.answerText}
          disabled={isReadOnly}
          onChange={(e) => onText(question.id, e.target.value)}
        />
      )}
    </QuestionCard>
  );
}
